export enum CharacterType {
  Astronaut = "astronaut",
  Cat = "cat",
  CatWoman = "catWoman",
  Punk = "punk",
  Viking = "viking",
  Death = "death",
  Alien = "alien",
  Physicist = "physicist",
}

export interface FrontUser {
  id?: number;
  uuid: string;
  email?: string;
  username: string;
  currency: number;
  tournamentTicket: number;
  characterIsSelected: string;
}
export enum ProductType {
  Sign = "sign",
  Skin = "skin",
  Stage = "stage",
  Ticket = "ticket",
  Life = "life",
  Emote = "emote",
  Pack = "pack",
  Avatar = "avatar",
}

export enum DeviceType {
  Mobile = "mobile",
  Tablet = "tablet",
  Tv = "tv",
}

export enum AvatarAssetType {
  Avatar = "avatar",
}

export enum SkinAssetType {
  Lobby = "lobby",
  Win = "win",
  Buzz = "buzz",
  Good = "good",
  Wrong = "wrong",
  Neutral = "neutral",
  Answer = "answer",
  Thinking = "thinking",
}

export enum SignAssetType {
  Panel = "panel",
  Tie = "tie",
}

export enum StageAssetType {
  Home = "home",
  GameNeutral = "gameNeutral",
  GameSuspense = "gameSuspense",
}

export enum EmoteAssetType {
  Emote = "emote",
}

export type DefaultAssetsType = {
  type: SignAssetType | SkinAssetType | StageAssetType | EmoteAssetType | AvatarAssetType;
  device?: DeviceType;
  url: string;
};

export type Product = {
  id: string;
  label: string;
  type: ProductType;
  character?: CharacterType;
  assets: DefaultAssetsType[];
};

export type UserProduct = {
  id?: string;
  productIdSelected: string;
  products: Product[];
};
